import { ButtonLink } from "@/components/button-link";
import { ArrowIcon } from "@/components/icon";
import config from "@/config";
import { DayRuler } from "@/features/landing/components/DayRuler.tsx";
import { FeedPost } from "@/features/landing/components/FeedPost.tsx";

export function Hero() {
	return (
		<section data-slot="hero">
			<div data-slot="wrap">
				<div data-slot="hero-grid">
					<div>
						<p data-slot="eyebrow">Diário de obra inteligente</p>
						<h1 data-slot="hero-title">
							Tudo que acontece na obra <em>vira relatório.</em>
						</h1>
						<p data-slot="hero-lede">
							O canteiro posta o dia com <strong>foto, clima e etapa</strong>. O
							engenheiro acompanha <strong>previsto × realizado</strong>. E o{" "}
							<strong>Relatório de Obra sai pronto em PDF</strong>, sem ninguém
							redigitar nada.
						</p>
						<div data-slot="hero-cta">
							<ButtonLink href={config.app.waitlistURL}>
								Entrar na lista de espera <ArrowIcon />
							</ButtonLink>
							<ButtonLink variant="outline" href="#dia">
								Ver um dia de obra
							</ButtonLink>
						</div>
						<p data-slot="hero-note">
							Funciona no navegador do computador e do celular.
						</p>
					</div>
					<FeedPost />
				</div>
				<DayRuler />
			</div>
		</section>
	);
}
